import React, { useEffect, useRef } from 'react';
import video from '../../assets/typing.mp4';
import Typed from "typed.js";
import { FaGithub } from "react-icons/fa";
import { FaLinkedinIn } from "react-icons/fa";
import { FaFile } from "react-icons/fa";
const Heroarea = () => {
    //for autoplay the video
    const vidRef=useRef();
   
    useEffect(() => { vidRef.current.play(); },[]);

    // ..for typeing
    const el = useRef(null);

    useEffect(() => {
      const typed = new Typed(el.current, {
        strings: ["Monika Hossan Momi"], // Strings to display
        // Speed settings, try diffrent values untill you get good results
        startDelay: 300,
        typeSpeed: 100,
        backSpeed: 100,
        backDelay: 100,
        smartBackspace: true,
        loop: true,
        showCursor: true
      });
  
      // Destropying
      return () => {
        typed.destroy();
      };
    }, []);
    return (
        <div>
            
            <div className="hero min-h-screen">
              
            {/* <video src={video} loop Hidecontrols autoPlay title="typing.mp4"></video> */}
            <video id="videoPlay" ref={ vidRef }  class="w-full embed-responsive overflow-hidden min-h-fit" autoplay loop muted>
                <source src={video} type="video/mp4"/>
            </video>
            <div className="hero-overlay bg-opacity-60"></div>
            <div className="hero-content text-center text-neutral-content">
                <div className="">
                <p className="mb-5 text-3xl">Hello there! I'm</p>
                <h1  className="mb-5 text-2xl lg:text-7xl  font-bold"><span ref={el}></span></h1>
                <p className="mb-5 text-3xl font-semibold">A Frontend Developer</p>
                {/* <button className="btn btn-white"><a href='Resume.pdf' target="_blank" rel="noreferrer" download>Resume</a></button> */}
             </div>
               
            </div>
            <div class="border-t border-b py-4 mt-7 border-gray-200 mt-80 z-[2]">
                        <div data-menu class="flex justify-between items-center cursor-pointer">
                            <div className='text-gray-600 flex'>
                            <a className='text-3xl text-white' href='https://github.com/devmonika'><FaGithub></FaGithub></a>
                            <a className='text-3xl text-white px-5' href='https://www.linkedin.com/in/monika-hossan-momi/'><FaLinkedinIn></FaLinkedinIn></a>
                            <a className='text-3xl text-white' href='Resume.pdf' download><FaFile></FaFile></a>
                            </div>
                            
                        </div>
                    </div>
            </div>
        </div>
    );
};

export default Heroarea;